import { CoreMenu } from 'src/@core/types';
import { environment } from 'src/environments/environment.development';
import { recruitmentMenu } from './recruitment.menu';

export const hr360Menu: CoreMenu[] = [
  {
    id: 'Employees',
    title: 'Employees',
    type: 'collapsible',
    icon: 'employees.svg',
    role: {
      roles: ['employee'],
      right: 'F1149',
    },
    children: [
      {
        id: 'All-Employees',
        title: 'All Employees',
        type: 'item',
        icon: 'employees.svg',
        url: '/hr360/employees/list/all',
        role: {
          roles: ['employee'],
          right: 'F1149',
        },
      },
    ],
  },
  {
    exactMatch: true,
    id: 'Self',
    title: 'Self',
    type: 'collapsible',
    icon: 'profile.svg',
    role: {
      roles: ['employee'],
      right: ['F1004', 'F1044'],
    },
    children: [
      {
        id: 'my-attendance',
        title: 'My Attendance',
        type: 'item',
        icon: 'attendance.svg',
        url: 'hr360/attendance/self',
        role: {
          roles: ['employee'],
          right: 'F1004',
        },
      },
      {
        exactMatch: true,
        id: 'my-leaves',
        title: 'My Leaves',
        type: 'item',
        icon: 'leaves.svg',
        url: 'hr360/leave-management/leaves',
        role: {
          roles: ['employee'],
          right: 'F1044',
        },
      },
      {
        exactMatch: true,
        id: 'my-attendance-summary',
        title: 'My Attendance Summary',
        type: 'item',
        icon: 'attendance.svg',
        url: 'hr360/attendance/summary/self',
        role: {
          roles: ['employee'],
          right: 'F1004',
        },
      },
      {
        exactMatch: true,
        id: 'my-payslip',
        title: 'My Payslip',
        type: 'item',
        icon: 'payroll.svg',
        url: 'hr360/payslip',
        role: {
          roles: ['employee'],
          right: 'F2073',
        },
      },
    ],
  },

  {
    id: 'Team',
    title: 'Team',
    type: 'collapsible',
    icon: 'my-team.svg',
    role: {
      roles: ['employee'],
      right: ['F1060', 'F1105'],
    },
    children: [
      {
        id: 'My-Team',
        title: 'My Team',
        type: 'item',
        icon: 'my-team.svg',
        url: '/hr360/employees/list/team',
        role: {
          roles: ['employee'],
          right: 'F1060',
        },
      },
      {
        id: 'team-attendance',
        title: 'Team Attendance',
        type: 'item',
        icon: 'team-attendance.svg',
        url: 'hr360/attendance/team',
        role: {
          roles: ['employee'],
          right: 'F1105',
        },
      },
      {
        id: 'team-attendance-summary',
        title: 'Team Attendance Summary',
        type: 'item',
        icon: 'team-attendance.svg',
        url: 'hr360/attendance/summary/team',
        role: {
          roles: ['employee'],
          right: 'F1105',
        },
      },
    ],
  },
  {
    id: 'Organization',
    title: 'Organization',
    type: 'collapsible',
    icon: 'organogram.svg',
    role: {
      roles: ['employee'],
      right: ['F1091', 'F1039', 'F1065'],
    },
    children: [
      {
        id: 'Policies',
        title: 'Policies',
        type: 'item',
        icon: 'policies.svg',
        url: 'hr360/organization/policies',
        role: {
          roles: ['employee'],
          right: 'F1091',
        },
      },
      {
        id: 'JDs',
        title: 'JDs',
        type: 'item',
        icon: 'jd.svg',
        url: 'hr360/organization/jd',
        role: {
          roles: ['employee'],
          right: 'F1039',
        },
      },
      {
        id: 'Organogram',
        title: 'Organogram',
        type: 'item',
        icon: 'organogram.svg',
        url: `hr360/organization/organogram`,
        role: {
          roles: ['employee'],
          right: 'F1065',
        },
      },
    ],
  },
  {
    exactMatch: true,
    id: 'Leaves',
    title: 'Leaves',
    type: 'collapsible',
    icon: 'leaves.svg',
    role: {
      roles: ['employee'],
      right: ['F1044', 'F1045', 'F1047', 'F1051', 'F1056'],
    },
    children: [
      {
        exactMatch: true,
        id: 'my-leaves',
        title: 'My Leaves',
        type: 'item',
        icon: 'leaves.svg',
        url: 'hr360/leave-management/leaves',
        role: {
          roles: ['employee'],
          right: 'F1044',
        },
      },
      {
        exactMatch: true,
        id: 'all-leaves',
        title: 'All Leaves',
        type: 'item',
        icon: 'all-leaves.svg',
        url: 'hr360/leave-management/leaves/all',
        role: {
          roles: ['employee'],
          right: 'F1045',
        },
      },
      {
        id: 'leaves-approval',
        title: 'Leaves Approval',
        type: 'item',
        icon: 'leave-approval.svg',
        url: 'hr360/leave-management/approval',
        role: {
          roles: ['employee'],
          right: 'F1047',
        },
      },
      {
        id: 'Leave-Quota',
        title: 'Leave Quota',
        type: 'item',
        icon: 'leave-quota.svg',
        url: 'hr360/leave-management/quota',
        role: {
          roles: ['employee'],
          right: 'F1051',
        },
      },
      {
        id: 'Leave-Types',
        title: 'Leave Types',
        type: 'item',
        icon: 'leave-type.svg',
        url: 'hr360/leave-management/types',
        role: {
          roles: ['employee'],
          right: 'F1056',
        },
      },
      {
        id: 'Encashable-Leave-Types',
        title: 'Encashable Leave Types',
        type: 'item',
        icon: 'encashment-leave-types.png',
        url: 'hr360/leave-management/encashable-leave-types',
        role: {
          roles: ['employee'],
          right: 'F2753',
        },
      },
      {
        id: 'Leave-Encashment-Hierarchy',
        title: 'Leave Encashment Hierarchy',
        type: 'item',
        icon: 'leave-encashment-hierarchy.png',
        url: 'hr360/leave-management/leave-encashment-hierarchy',
        role: {
          roles: ['employee'],
          right: 'F2751',
        },
      },
      {
        id: 'Leave-Encashment-Approvals',
        title: 'Leave Encashment Approvals',
        type: 'item',
        icon: 'leave-encashment-request.png',
        url: 'hr360/leave-management/leave-encashment-request',
        role: {
          roles: ['employee'],
          right: 'F2750',
        },
      },
      {
        id: 'My-Encashment-Requests',
        title: 'My Encashment Requests',
        type: 'item',
        icon: 'my-encashment-requests.png',
        url: 'hr360/leave-management/my-encashment-requests',
        role: {
          roles: ['employee'],
          right: 'F2649',
        },
      },
      {
        id: 'Leave-Encashment-Payout',
        title: 'Leave Encashment Payout',
        type: 'item',
        icon: 'encashment-leave-types.png',
        url: 'hr360/leave-management/leave-encashment-payout',
        role: {
          roles: ['employee'],
          right: 'F2752',
        },
      },
      {
        id: 'Leave-Settings',
        title: 'Leave Settings',
        type: 'item',
        icon: 'leave-setting.svg',
        url: 'hr360/leave-management/settings',
        role: {
          roles: ['employee'],
          right: 'F2983',
        },
      },
    ],
  },
  {
    id: 'Broadcast',
    title: 'Broadcast',
    type: 'collapsible',
    icon: 'announcements.svg',
    role: {
      roles: ['employee'],
      right: ['F1061', 'F1000', 'F1097'],
    },
    children: [
      {
        id: 'News',
        title: 'News',
        type: 'item',
        icon: 'news.svg',
        url: 'hr360/broadcast/news',
        role: {
          roles: ['employee'],
          right: 'F1061',
        },
      },
      {
        id: 'Announcements',
        title: 'Announcements',
        type: 'item',
        icon: 'announcements.svg',
        url: 'hr360/broadcast/announcements',
        role: {
          roles: ['employee'],
          right: 'F1000',
        },
      },
      {
        id: 'Posts',
        title: 'Posts',
        type: 'item',
        icon: 'posts.svg',
        url: `hr360/broadcast/posts`,
        role: {
          roles: ['employee'],
          right: 'F1097',
        },
      },
    ],
  },
  {
    id: 'Payroll',
    title: 'Payroll',
    type: 'item',
    icon: 'payroll.svg',
    url: `${environment.payroll_url}/payrolls`,
    externalUrl: true,
    role: {
      roles: ['employee'],
      right: 'F1066',
    },
  },
  // {
  //   id: 'FNF',
  //   title: 'FNF',
  //   type: 'item',
  //   icon: 'fnf.svg',
  //   url: `${environment.fnf_url}`,
  //   externalUrl: true,
  //   role: {
  //     roles: ['employee'],
  //     right: 'F1439',
  //   },
  // },
  {
    id: 'Reports',
    title: 'Reports',
    type: 'item',
    icon: 'report.svg',
    url: '/hr360/reports',
    role: {
      roles: ['employee'],
      right: 'F1101',
    },
  },
  {
    id: 'Analytics-Reports',
    title: 'HR Reports',
    type: 'item',
    icon: 'analytic-report.svg',
    url: '/hr360/analytics-reports',
    externalUrl: false,
    role: {
      roles: ['employee'],
      right: 'F2549',
    },
  },
  {
    id: 'Vacation Proxy',
    title: 'Vacation Proxy',
    type: 'item',
    icon: 'vacation-proxy.svg',
    url: '/hr360/vacation-proxy',
    role: {
      roles: ['employee'],
      right: 'F1136',
    },
  },
  {
    id: 'Calendar',
    title: 'Calendar',
    type: 'item',
    icon: 'calendar.svg',
    url: '/hr360/calendar',
    role: {
      roles: ['employee'],
      right: 'F5442',
    },
  },
  {
    id: 'Polls',
    title: 'Polls',
    type: 'item',
    icon: 'polls.svg',
    url: '/hr360/polls',
    role: {
      roles: ['employee'],
      right: 'F1139',
    },
  },
  ...recruitmentMenu,
  {
    exactMatch: true,
    id: 'Loans-Advances',
    title: 'Loans and Advances',
    type: 'collapsible',
    icon: 'L&A.svg',
    role: {
      roles: ['employee'],
      right: ['F1158'],
    },
    children: [
      {
        exactMatch: true,
        id: 'loans-and-advances',
        title: 'Loans and Advances',
        type: 'item',
        icon: 'L&A.svg',
        url: 'hr360/loans-advances',
        role: {
          roles: ['employee'],
          right: 'F1158',
        },
      },
      {
        exactMatch: true,
        id: 'loans-advances-hierarchy',
        title: 'Hierarchy',
        type: 'item',
        icon: 'hierarchy-L&A.svg',
        url: 'hr360/loans-advances/hierarchy',
        role: {
          roles: ['employee'],
          right: 'F1160',
        },
      },
      {
        exactMatch: true,
        id: 'loans-advances-approvals',
        title: 'Approvals',
        type: 'item',
        icon: 'approvals-L&A.svg',
        url: 'hr360/loans-advances/approvals',
        role: {
          roles: ['employee'],
          right: 'F1159',
        },
      },
    ],
  },
  {
    id: 'Appraisal',
    title: 'Appraisal',
    type: 'item',
    icon: 'appraisals.svg',
    url: `${environment.appraisals_url}`,
    externalUrl: true,
    role: {
      roles: ['employee'],
      right: 'F1170',
    },
  },
  {
    id: 'Todo',
    title: 'Todo',
    type: 'item',
    icon: 'TODO.svg',
    url: '/hr360/todos',
    role: {
      roles: ['employee'],
      right: 'F1193',
    },
  },
  {
    id: 'Task Management',
    title: 'Task Management',
    type: 'item',
    icon: 'task-managemnet.svg',
    url: '/hr360/task-management',
    role: {
      roles: ['employee'],
      right: 'F2012',
    },
  },
  {
    id: 'Claims',
    title: 'Claims',
    type: 'collapsible',
    icon: 'claim-requests.svg',
    role: {
      roles: ['employee'],
      right: ['F3257'],
    },
    children: [
      {
        id: 'claim-approvals',
        title: 'Claim Approvals',
        type: 'item',
        icon: 'claim-approvals.svg',
        url: 'hr360/claims/claim-approvals',
        role: {
          roles: ['employee'],
          right: 'F3289',
        },
      },
      {
        id: 'my-claim-request',
        title: 'My Claim Request',
        type: 'item',
        icon: 'claim-requests.svg',
        url: 'hr360/claims/my-claim-request',
        role: {
          roles: ['employee'],
          right: 'F3292',
        },
      },
      {
        id: 'claim-payout',
        title: 'Claim Payout',
        type: 'item',
        icon: 'claim-payouts.svg',
        url: 'hr360/claims/claim-payout',
        role: {
          roles: ['employee'],
          right: 'F3291',
        },
      },
      {
        id: 'claim-hierarchy',
        title: 'Claim Hierarchy',
        type: 'item',
        icon: 'claim-hierarchy.svg',
        url: 'hr360/claims/claim-hierarchy',
        role: {
          roles: ['employee'],
          right: 'F3290',
        },
      },
    ],
  },
  {
    id: 'training-development',
    title: 'Training & Development',
    type: 'collapsible',
    icon: 'skills.svg',
    role: {
      roles: ['employee'],
      right: ['F3591'],
    },
    children: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        icon: 'skills-dashboard.svg',
        url: 'hr360/skill-training/dashboard',
        role: {
          roles: ['employee'],
          right: 'F3591',
        },
      },
      {
        id: 'skills',
        title: 'Skills',
        type: 'item',
        icon: 'skills.svg',
        url: 'hr360/skill-training/skills',
        role: {
          roles: ['employee'],
          right: 'F4123',
        },
      },
      {
        id: 'skill-categories',
        title: 'Skill Categories',
        type: 'item',
        icon: 'skill-categories.svg',
        url: 'hr360/skill-training/skill-categories',
        role: {
          roles: ['employee'],
          right: 'F4121',
        },
      },
      {
        id: 'skill-levels',
        title: 'Skill Levels',
        type: 'item',
        icon: 'skills-levels.svg',
        url: 'hr360/skill-training/skill-levels',
        role: {
          roles: ['employee'],
          right: 'F4122',
        },
      },
      {
        id: 'designation-skill',
        title: 'Designation Skill',
        type: 'item',
        icon: 'designation-skills.svg',
        url: 'hr360/skill-training/designation-skill',
        role: {
          roles: ['employee'],
          right: 'F4119',
        },
      },
      {
        id: 'employee-skill',
        title: 'Employee Skill',
        type: 'item',
        icon: 'employee_skills.svg',
        url: 'hr360/skill-training/employee-skill',
        role: {
          roles: ['employee'],
          right: 'F4120',
        },
      },
      {
        id: 'skill-gap-analysis',
        title: 'Skill Gap Analysis',
        type: 'item',
        icon: 'skills-gap-analysis.svg',
        url: 'hr360/skill-training/skill-gap-analysis',
        role: {
          roles: ['employee'],
          right: 'F4113',
        },
      },
      {
        id: 'training-recommendation',
        title: 'Training Recommendation',
        type: 'item',
        icon: 'training_recommendation.svg',
        url: 'hr360/skill-training/training-recommendation',
        role: {
          roles: ['employee'],
          right: 'F4114',
        },
      },
      {
        id: 'training',
        title: 'Training',
        type: 'item',
        icon: 'trainings.svg',
        url: 'hr360/skill-training/training',
        role: {
          roles: ['employee'],
          right: 'F4128',
        },
      },
      {
        id: 'employee-training',
        title: 'Employee Training',
        type: 'item',
        icon: 'employee-trainings.svg',
        url: 'hr360/skill-training/employee-training',
        role: {
          roles: ['employee'],
          right: 'F4125',
        },
      },
      {
        id: 'training-completion',
        title: 'Training Completion',
        type: 'item',
        icon: 'training-completion.svg',
        url: 'hr360/skill-training/training-completion',
        role: {
          roles: ['employee'],
          right: 'F4127',
        },
      },
      {
        id: 'my-training',
        title: 'My Training',
        type: 'item',
        icon: 'my-training.svg',
        url: 'hr360/skill-training/my-training',
        role: {
          roles: ['employee'],
          right: 'F4126',
        },
      },
    ],
  },
  {
    id: 'Certificate-Management',
    title: 'Certificate Management',
    type: 'collapsible',
    icon: 'policies.svg',
    role: {
      roles: ['employee'],
      right: ['F3851'],
    },
    children: [
      {
        id: 'certificates-list',
        title: 'Templates List',
        type: 'item',
        icon: 'certificate-templates.svg',
        url: 'hr360/certificates',
        exactMatch: true,
        role: {
          roles: ['employee'],
          right: 'F4116',
        },
      },
      {
        id: 'issue-certificates',
        title: 'Issue Certificate',
        type: 'item',
        icon: 'issue-certificate.svg',
        url: 'hr360/certificates/issue',
        role: {
          roles: ['employee'],
          right: 'F4117',
        },
      },
    ],
  },

];
